import React, { useState } from "react";
import { Button, Modal } from "react-materialize";
import Html from "utils/Html";
import { useNotify } from "context/NotifyContext";
import handleEvents from "components/notify/handleEvents";

export default function ModalRemoveItems() {
  const { filters, dispatch } = useNotify();
  const [removeItem, setRemoveItem] = useState({
    status: "",
    err: 0,
    err_msg: "",
  });
  const modalCSS = {
    width: "400px",
    maxHeight: "230px",
  };
  let header = "Remove Item";

  const content =
    removeItem.err === 1 ? (
      <div className="text-error">Fetch request error: {removeItem.err_msg}</div>
    ) : removeItem.status === "inprocess" ? (
      <Html.Preloading
        addon={{
          css: {
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            margin: "auto",
          },
        }}
      />
    ) : (
      <div className="modal-content-outer">
        <div className="modal-content-inner">
          <p>
            <span
              style={{
                display: "block",
                textAlign: "center",
                marginTop: "25px",
              }}
            >
              Are you sure you want to remove it?
            </span>
          </p>
          <Button
            id="btn-confirm-removeitems"
            node="button"
            waves="light"
            small={true}
            style={{
              width: "100px",
              borderRadius: "20px",
              margin: "0 auto",
              display: "block",
            }}
            onClick={(evt) =>
              handleEvents.BtnConfirmRemoveItems.OnClick(
                filters,
                dispatch,
                setRemoveItem
              )
            }
          >
            Confirm
          </Button>
        </div>
        <div className="modal-loading hide">
          <Html.Preloading
            addon={{
              css: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto",
              },
            }}
          />
        </div>
      </div>
    );

  return (
    <Modal
      actions={[
        <div className="header">{header}</div>,
        <Button
          flat
          modal="close"
          node="button"
          waves="red"
          className="modal-close"
        >
          <i className="material-icons">close</i>
        </Button>,
      ]}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user modal-user-footer"
      id="modal-remove-items"
      open={filters?.isOpenModalRemoveItem}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseStart: () =>
          handleEvents.BtnConfirmRemoveItems.OnClose(
            filters,
            dispatch,
            setRemoveItem
          ),
        preventScrolling: true,
        startingTop: "5%",
      }}
      root={document.getElementById("root")}
      style={modalCSS}
    >
      {content}
    </Modal>
  );
}
